export default "__VITE_ASSET__7F274BKM__"